<template>
  <div class="tab-pane__content">
    <div class="btn-group mb-3">
      <ComponentInput
        placeholder="Укажите модуль"
        :select2Settings="select2Settings"
        :select2Options="modules"
        v-model="moduleId"
        type="select2"
        :disabled="isSaving"
      />
      <ButtonComponent class="ml-2" mod="gradient-bg" buttonType="button" @click="edit" v-if="!isEditMode">
        Редактировать
      </ButtonComponent>
      <ButtonComponent
        class="ml-2"
        mod="gradient-bg"
        buttonType="button"
        @click="save"
        v-if="isEditMode"
        :disabled="isSaving"
      >
        Сохранить
      </ButtonComponent>
      <ButtonComponent
        class="ml-2"
        mod="border"
        buttonType="button"
        @click="reload"
        v-if="isEditMode"
        :disabled="isSaving"
      >
        Отмена
      </ButtonComponent>
    </div>

    <div class="table-roles-container">
      <div v-if="!loading" class="table-scroll-container" ref="tableContainer" @scroll.passive="updateSyncedScroll">
        <table ref="table" class="scrolling">
          <thead ref="thead" @dragenter="onDragEnterHeader" @dragover.prevent="onDragOverHeader" @drop="onDropHeader">
            <tr v-if="rolesInner">
              <th class="table__sticky-ceil" scope="col"></th>
              <th class="table__ceil" v-for="item in rolesInner" :key="item" scope="col">
                <span v-if="item.isGroupRole">Группа - </span>
                {{ item.title }}
              </th>
            </tr>
            <tr v-if="rolesInner">
              <th class="table__sticky-ceil" scope="col">Выбрать все</th>
              <th class="scrolling__ceil" v-for="item in rolesInner" :key="item" scope="col">
                <button
                  @click="onSelectAllClick(item)"
                  class="m-auto scrolling__indicator dis-btn-css"
                  :class="getIndicatorClass(item)"
                ></button>
              </th>
            </tr>
          </thead>
          <tbody ref="tbody">
            <tr v-for="perm in permissionsInner" :key="perm">
              <th class="table__sticky-ceil" scope="row">
                <span v-if="perm.parentId > 0">&nbsp;&nbsp;&nbsp;&nbsp;{{ perm.id }}. {{ perm.name }}</span>
                <b v-else>{{ perm.id }}. {{ perm.name }}</b>
              </th>
              <td class="scrolling__ceil" v-for="role in rolesInner" :key="role">
                <button
                  @click="changeRolePermission(role, perm)"
                  class="m-auto scrolling__indicator dis-btn-css"
                  :class="{
                    'scrolling__indicator--dis-pseudo': accessMatrixInner && accessMatrixInner[role.id][perm.id],
                    editing: isEditMode,
                  }"
                ></button>
                <div v-if="!isEditMode" class="table__overlay"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-32">
      <Loader v-if="loading"></Loader>
    </div>
  </div>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import { PERMISSION_CHECKS_ACTIONS_NAME } from '@/common/store/permissionChecks/name';

  import Loader from '@/components/Loader.vue';

  import Api from '@/modules/admin/api/rolesPermissions.js';

  export default {
    name: 'TableRolesPermissions',
    props: {
      deadAreaColor: { type: String, required: false, default: '#CCC' },
    },
    components: {
      ButtonComponent,
      Loader,
      ComponentInput,
    },
    data() {
      return {
        rolesInner: null,
        permissionsInner: null,
        accessMatrixInner: null,
        isEditMode: false,
        isSaving: false,
        loading: false,
        moduleId: 1,
        modules: [],
        select2Settings: Constants.select2SettingsNoClear,
      };
    },
    watch: {
      deadAreaColor() {
        this.setColors();
      },
      moduleId() {
        this.load();
      },
      loading(newVal) {
        if (!newVal) {
          this.fixStickyHeaders();
        }
      },
    },
    mounted: function () {
      this.setColors();
      if (this.rolesInner === null || this.permissionsInner === null || this.accessMatrixInner === null) {
        this.load();
      }
    },
    created() {
      this.loadModules();
    },
    methods: {
      fixStickyHeaders() {
        this.$nextTick(() => {
          const thead = this.$refs.thead;
          if (!thead) return;
          const rows = thead.querySelectorAll('tr');
          let topOffset = 0;
          rows.forEach((tr, i) => {
            const isLastRow = i === rows.length - 1;
            tr.querySelectorAll('th').forEach((th) => {
              th.style.position = 'sticky';
              th.style.top = topOffset + 'px';
              th.style.boxShadow = isLastRow ? '0 2px 0 #ddd' : 'none';
              // угловые ячейки (первый столбец) — прибиваем ещё и к левому краю
              if (th.classList.contains('table__sticky-ceil')) {
                th.style.left = '0';
                th.style.zIndex = '3';
              } else {
                th.style.zIndex = '2';
              }
            });
            topOffset += tr.offsetHeight;
          });
        });
      },
      loadModules() {
        Api.getModules().then((response) => {
          this.modules = response.data;
        });
      },
      load() {
        this.loading = true;
        Promise.all([
          Api.loadRoles(),
          Api.loadPermissionsForMatrix(this.moduleId),
          Api.loadPermissionAccessMatrix(this.moduleId),
        ]).then(([r1, r2, r3]) => {
          this.rolesInner = r1.data.items;
          this.permissionsInner = r2.data.filter((x) => !x.isSystem);
          this.accessMatrixInner = r3.data;
          this.loading = false;
        });
      },
      changeRolePermission(it, item) {
        if (!it.parentId || this.accessMatrixInner[it.parentId][item.id]) {
          let newValue = !this.accessMatrixInner[it.id][item.id];
          this.accessMatrixInner[it.id][item.id] = newValue;
          if (it.isGroupRole && newValue === false) {
            let childRoles = this.rolesInner.filter((x) => x.parentId == it.id);
            childRoles.forEach((cr) => (this.accessMatrixInner[cr.id][item.id] = newValue));
          }
        }
      },
      edit() {
        this.isEditMode = true;
      },
      reload() {
        this.isEditMode = false;
        this.load();
      },
      save() {
        this.isSaving = true;
        Api.updatePermissionAccessMatrix(this.moduleId, this.accessMatrixInner)
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
            this.load();
          })
          .then(() => {
            this.load();
            this.$store.dispatch(PERMISSION_CHECKS_ACTIONS_NAME.resetPermissionChecks);
          })
          .finally(() => {
            this.isEditMode = false;
            this.isSaving = false;
          });
      },
      updateSyncedScroll() {
        const c = this.$refs.tableContainer;
        if (!c) return;
        this.$emit('scroll', c.scrollTop, c.scrollLeft, c.scrollHeight, c.scrollWidth);
      },
      setColors() {
        const t = this.$refs.table;
        if (!t) return;
        t.style.setProperty('--dead-area-color', this.deadAreaColor);
      },
      onDragEnterHeader(e) {
        this.$emit('header-dragenter', e);
      },
      onDragOverHeader(e) {
        this.$emit('header-dragover', e);
      },
      onDropHeader(e) {
        this.$emit('header-drop', e);
      },
      onSelectAllClick(role) {
        if (this.isEditMode) {
          if (!role.parentId) {
            let selected = this.getAllSelected(role.id);
            Object.keys(this.accessMatrixInner[role.id]).forEach(
              (x) => (this.accessMatrixInner[role.id][x] = !selected),
            );
            if (selected)
              this.rolesInner
                .filter((x) => x.parentId == role.id)
                .forEach((x) =>
                  Object.keys(this.accessMatrixInner[x.id]).forEach((p) => (this.accessMatrixInner[x.id][p] = false)),
                );
          } else {
            let groupSelected = this.getAllGroupSelected(role);
            Object.keys(this.accessMatrixInner[role.id])
              .filter((x) => this.accessMatrixInner[role.parentId][x] == true)
              .forEach((x) => (this.accessMatrixInner[role.id][x] = !groupSelected));
          }
        }
      },
      getAllSelected(roleId) {
        if (this.accessMatrixInner)
          return Object.keys(this.accessMatrixInner[roleId]).every((x) => this.accessMatrixInner[roleId][x] == true);
        else return false;
      },
      getAllGroupSelected(role) {
        if (!role.parentId) return false;

        if (this.accessMatrixInner)
          return (
            Object.keys(this.accessMatrixInner[role.id]).every(
              (x) => this.accessMatrixInner[role.id][x] == this.accessMatrixInner[role.parentId][x],
            ) && Object.keys(this.accessMatrixInner[role.id]).some((x) => this.accessMatrixInner[role.id][x] == true)
          );
        else return false;
      },
      getIndicatorClass(role) {
        let resultClass = '';
        if (this.getAllSelected(role.id)) resultClass = 'scrolling__indicator--dis-pseudo';
        else if (this.getAllGroupSelected(role)) {
          resultClass = 'scrolling__indicator--dis-pseudo_group';
        }

        if (this.isEditMode && resultClass) resultClass = resultClass + ' editing';

        return resultClass;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/global/variables.scss';
  @import '@/assets/theme/default/global/mixin.scss';

  .btn-group {
    i {
      font-size: 20px;
      color: $yellow;
    }
  }

  .table-roles-container {
    padding: 0 80px;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
  }

  .table-scroll-container {
    width: 100%;
    max-height: 95vh;
    overflow: auto;
    scrollbar-width: thin;
  }

  table.scrolling {
    border-collapse: separate;
    border-spacing: 0;
    font: $fira-12;
    width: 100%;
    table-layout: auto;

    thead th {
      position: sticky;
      /* top устанавливается через JS в fixStickyHeaders() */
      z-index: 2;
      background-color: white;
      font-weight: bold;

      span {
        font-weight: bold;
      }
    }

    td,
    th {
      border-right: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      overflow: hidden;
      word-wrap: break-word;
      padding: 8px;
    }

    thead tr:first-child th {
      border-top: 1px solid #ddd;
    }

    td {
      background-color: #fff;
    }

    th {
      background-color: white;
    }
  }

  .scrolling__ceil {
    vertical-align: middle;
    cursor: pointer;
    min-width: 100px;
    height: 40px;
  }

  td.scrolling__ceil {
    position: relative;
  }

  .table__ceil {
    min-width: 100px;
  }

  .scrolling__indicator {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;

    &::before {
      content: '';
      position: absolute;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      background: lightgray;
      top: 50%;
      left: 50%;
      margin-right: -50%;
      transform: translate(-50%, -50%);
      display: none;
    }

    &--dis-pseudo::before {
      display: block;
    }
    &.editing::before {
      background: #6c757d !important;
    }

    &--dis-pseudo_group::before {
      display: block;
      background: #e9e9e9 !important;
    }

    &--dis-pseudo_group {
      &.editing::before {
        background: #b6babe !important;
      }
    }
  }

  .table {
    &__sticky-ceil {
      position: sticky;
      left: 0;
      z-index: 1;
      min-width: 236px;
      max-width: 236px;
      background-color: white;
      border-left: 1px solid #ddd;
    }

    &__overlay {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  /* Corner cell in sticky thead needs higher z-index */
  thead .table__sticky-ceil {
    z-index: 3;
  }
</style>
